import React from 'react'

export default function FaceFeature({ scale, verticalOffset = 0 }) {
  const transformOrigin = '23 7.5'

  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-origin={transformOrigin}>
      <path
        d="M19.7998 3.70993C19.7998 3.70993 23.4198 2.63993 26.1098 3.70993"
        stroke="#FCE5AC"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M16.7998 1.67993H29.1198" stroke="#FCE5AC" strokeWidth="0.5" strokeMiterlimit="10" />
      <path
        d="M10.1099 0.710017C17.4599 0.710017 20.1499 2.73999 20.2499 6.05999C20.3499 9.37999 16.1099 15.26 9.07992 15.05C2.03992 14.84 1.31993 7.98999 2.14993 4.24999C2.96993 0.499995 7.82989 0.710017 10.1099 0.710017Z"
        stroke="#FCE5AC"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M35.8097 0.710017C28.4597 0.710017 25.7697 2.73999 25.6697 6.05999C25.5697 9.37999 29.8097 15.26 36.8397 15.05C43.8697 14.84 44.5997 7.98999 43.7697 4.24999C42.9497 0.499995 38.0797 0.710017 35.8097 0.710017Z"
        stroke="#FCE5AC"
        strokeMiterlimit="10"
        fill="none"
      />
      <path d="M44.3198 6.48999H45.0798" stroke="#FCE5AC" strokeMiterlimit="10" strokeLinecap="round" />
      <path d="M0.839844 6.48999H1.59979" stroke="#FCE5AC" strokeMiterlimit="10" strokeLinecap="round" />
      <path
        d="M5.82962 14.35C5.10962 14.08 4.43957 13.66 3.84958 13.13C3.28958 12.57 2.82962 11.92 2.45962 11.21C1.75962 9.78004 1.49962 8.16998 1.51962 6.58998C1.53962 5.79998 1.6196 5.01 1.8096 4.24C1.9996 3.44 2.40958 2.66001 3.03958 2.12001C4.30958 1.02001 5.96959 0.800012 7.48959 0.810012C6.73959 0.960012 5.97958 1.11003 5.28958 1.39003C4.58958 1.64003 3.9296 2.01998 3.4396 2.52998C2.9596 3.04998 2.6296 3.68003 2.4996 4.39003C2.3496 5.12003 2.27962 5.86 2.26962 6.61C2.22962 8.1 2.44958 9.58998 2.97958 10.97C3.52958 12.35 4.50962 13.55 5.82962 14.35Z"
        fill="#D08629"
      />
      <path
        d="M14.2597 1.03003C15.8497 1.14003 17.5097 1.47006 18.8797 2.50006C19.5697 3.00006 20.0897 3.75006 20.3697 4.56006C20.6397 5.38006 20.6997 6.25005 20.5697 7.11005C20.2297 8.78005 19.3497 10.2501 18.2197 11.4401C17.6497 12.0301 17.0297 12.5601 16.3497 13.0201C15.6597 13.4501 14.9397 13.83 14.1797 14.09C15.5697 13.28 16.7997 12.2701 17.7897 11.0601C18.7697 9.86006 19.5597 8.46004 19.8397 6.98004C20.0897 5.53004 19.6697 3.93007 18.5197 2.95007C17.3697 1.93007 15.7997 1.44003 14.2597 1.03003Z"
        fill="#D08629"
      />
      <path
        d="M40.1197 14.35C41.4397 13.54 42.4197 12.35 42.9597 10.97C43.4897 9.58998 43.7097 8.09 43.6697 6.61C43.6597 5.87 43.5897 5.12003 43.4397 4.39003C43.3097 3.69003 42.9797 3.04998 42.4997 2.52998C42.0097 2.01998 41.3597 1.64003 40.6497 1.39003C39.9497 1.10003 39.1997 0.960012 38.4497 0.810012C39.9697 0.800012 41.6297 1.02001 42.8997 2.12001C43.5297 2.66001 43.9397 3.45 44.1297 4.24C44.3097 5.01 44.3897 5.79998 44.4197 6.58998C44.4497 8.15998 44.1897 9.77004 43.4797 11.21C43.1197 11.92 42.6497 12.57 42.0897 13.13C41.5097 13.66 40.8397 14.08 40.1197 14.35Z"
        fill="#D08629"
      />
      <path
        d="M31.6897 1.03003C30.1497 1.44003 28.5797 1.93006 27.4397 2.94006C26.2897 3.92006 25.8697 5.52003 26.1197 6.97003C26.3997 8.45003 27.1897 9.84005 28.1697 11.05C29.1497 12.26 30.3897 13.2701 31.7797 14.0801C31.0197 13.8201 30.2997 13.4401 29.6097 13.0101C28.9397 12.5501 28.3097 12.0201 27.7397 11.4301C26.6097 10.2501 25.7197 8.78004 25.3897 7.10004C25.2497 6.25004 25.3197 5.37005 25.5897 4.55005C25.8797 3.74005 26.3897 2.99005 27.0797 2.49005C28.4397 1.47005 30.0997 1.14003 31.6897 1.03003Z"
        fill="#D08629"
      />
    </g>
  )
}
